import { BillBalanceModifierReference } from '@features/bills/enums/BillBalanceModifierReference'

import { EmberRoute } from '../../../../../enums/emberRoute'
import { reactRoute } from '../../../../../utils/routing/reactRoute'

export const getBillPaymentPaneItemRouteMap = (modifierId: string): Record<BillBalanceModifierReference, string> => ({
  [BillBalanceModifierReference.BankPayment]: EmberRoute.BankPayment,
  [BillBalanceModifierReference.Bill]: reactRoute.organization.bills.getViewBillRoute(modifierId),
  [BillBalanceModifierReference.ContactBalancePayment]: EmberRoute.ContactBalancePayment,
  [BillBalanceModifierReference.DaybookTransaction]: EmberRoute.DaybookTransaction,
})

export const getBillPaymentPaneItemRoute = (
  balanceModifierReference: BillBalanceModifierReference,
  modifierId: string,
): string => getBillPaymentPaneItemRouteMap(modifierId)[balanceModifierReference]
